import { PickOrderDetailFragment } from '../../../graphql'

export type ShippingAddress = NonNullable<PickOrderDetailFragment['shippingAddress']>

/** "Kansas City, MO 64105", or as much of it as the address has. */
export function cityLine( address: ShippingAddress ): string {
	return [ address.city, [ address.state, address.postalCode ].filter( Boolean ).join( ' ' ) ]
		.filter( Boolean )
		.join( ', ' )
}

/**
 * The street address on one line, for pasting into a carrier's address field.
 * The recipient's name and company are left off; they go in fields of their own.
 */
export function singleLineAddress( address: ShippingAddress ): string {
	return [ address.line1, address.line2, cityLine( address ) ].filter( Boolean ).join( ', ' )
}
